var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"fab":"","color":_vm.color,"small":""},on:{"click":function($event){return _vm.$emit('filter-contract-before-date')}}},on),[_c('v-icon',{attrs:{"size":"18"}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }